module.exports = __webpack_public_path__ + "img/title5.74798f06.png";